import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.filter((it:any) => {
      console.log(it)
      if(it.senderName){
        return it.senderName.toLocaleLowerCase().includes(searchText);
      }else
      return it.firstName.toLocaleLowerCase().includes(searchText);
    });
  }
}
